import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { useLayout7Theme } from './theme';
import './styles.css';

interface Layout7RootProps {
  children: ReactNode;
  className?: string;
  withHeader?: boolean;
}

export function Layout7Root({ children, className, withHeader }: Layout7RootProps) {
  const { themeStyle } = useLayout7Theme();

  return (
    <div
      className={cn(
        'layout-7 min-h-screen bg-[var(--wl7-bg)]',
        withHeader && 'layout-7-with-header',
        className
      )}
      style={themeStyle}
    >
      {children}
    </div>
  );
}
